import React from "react";
import { Stack } from "@mui/material";
import { Link } from "gatsby";
import CTAButton from "./CTAButton";
import TransparentButton from "./TransparentButton";
import { colours } from "../../constants/colourConstants";
import { css } from "glamor"
import ArrowIcon from '../../images/back-2px.svg'

const SalesButtons = ({
    themes = { primaryButtonTheme: "blue", secondaryButtonTheme: "greys" },
    backgroundColorType = "light",
    sx,
    primaryButtonSx,
    secondaryButtonSx,
}) => {

    const themeIsLowerContrast = (theme) => theme.includes("orange") || theme.includes("green")

    const getPrimaryTheme = () => {
        const theme = themes.primaryButtonTheme ? themes.primaryButtonTheme : "blue";
        const shade = themeIsLowerContrast(theme) ? 600 : 700

        return {
            backgroundColor: colours.primary[theme][shade]
        }
    }

    const getSecondaryTheme = () => {
        const theme = themes.secondaryButtonTheme ? themes.secondaryButtonTheme : themes.primaryButtonTheme

        return backgroundColorType === "light" ?
            {
                color: colours.primary[theme][500],
                border: `1px solid ${colours.primary[theme][300]}`
            } : {
                color: colours.white,
                border: `1px solid ${colours.white}`
            }
    }

    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ marginTop: "36px", marginBottom: "36px", flexShrink: 0, ...sx }}
        >
            <CTAButton
                {...css({
                    display: "flex",
                    height: 40,
                    padding: "0px 12px",
                    alignItems: "center",
                    ...getPrimaryTheme(),
                    ...primaryButtonSx
                })}
            >
                <Link
                    to="/get-a-demo"
                    style={{
                        color: "inherit",
                        width: "100%",
                        height: "100%",
                    }}
                >
                    <Stack direction="row" alignItems="center" sx={{ height: "100%" }}>
                        Get a demo
                        <img
                            {...css({ marginLeft: 12 })}
                            alt="ArrowIcon"
                            src={ArrowIcon}
                        />
                    </Stack>
                </Link>
            </CTAButton>
            <TransparentButton
                {...css({
                    height: 40,
                    padding: "0px 12px",
                    ...getSecondaryTheme(),
                    ...secondaryButtonSx
                })}
            >
                <Link
                    to="/free-trial"
                    style={{
                        color: "inherit",
                        width: "100%",
                        height: "100%"
                    }}
                >
                    <Stack direction="row" alignItems="center" sx={{ height: "100%" }}>
                        Try for free
                    </Stack>
                </Link>
            </TransparentButton>
        </Stack>
    )
}

export default SalesButtons